import HTTPEdition from '../HTTPEdition';

const URL_BASE = 'Edition/PrintAsync';
export default async function edition(payload) {
  const config = {
    responseType: 'blob',
  };
  
  if (!payload.typeEdition || payload.typeEdition === '') {
    delete payload.typeEdition;
  }

  const response = await HTTPEdition.post(URL_BASE, payload, config);
  return response;
}